"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useUniqueId;

var _react = require("react");

var _mathRandom = _interopRequireDefault(require("math-random"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-magic-numbers: ["error", { "ignore": [2, 5, 36] }] */
function useUniqueId(prefix) {
  var id = (0, _react.useMemo)(function () {
    return (0, _mathRandom.default)().toString(36).substr(2, 5);
  }, []);
  prefix = prefix ? "".concat(prefix, "--") : '';
  return "".concat(prefix).concat(id);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VVbmlxdWVJZC50cyJdLCJuYW1lcyI6WyJ1c2VVbmlxdWVJZCIsInByZWZpeCIsImlkIiwidG9TdHJpbmciLCJzdWJzdHIiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFFQTs7QUFDQTs7OztBQUhBO0FBS2UsU0FBU0EsV0FBVCxDQUFxQkMsTUFBckIsRUFBOEM7QUFDM0QsTUFBTUMsRUFBRSxHQUFHLG9CQUFRO0FBQUEsV0FBTSwyQkFBU0MsUUFBVCxDQUFrQixFQUFsQixFQUFzQkMsTUFBdEIsQ0FBNkIsQ0FBN0IsRUFBZ0MsQ0FBaEMsQ0FBTjtBQUFBLEdBQVIsRUFBa0QsRUFBbEQsQ0FBWDtBQUVBSCxFQUFBQSxNQUFNLEdBQUdBLE1BQU0sYUFBTUEsTUFBTixVQUFtQixFQUFsQztBQUVBLG1CQUFVQSxNQUFWLFNBQW1CQyxFQUFuQjtBQUNEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyIvKiBlc2xpbnQgbm8tbWFnaWMtbnVtYmVyczogW1wiZXJyb3JcIiwgeyBcImlnbm9yZVwiOiBbMiwgNSwgMzZdIH1dICovXG5cbmltcG9ydCB7IHVzZU1lbW8gfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgcmFuZG9tIGZyb20gJ21hdGgtcmFuZG9tJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlVW5pcXVlSWQocHJlZml4Pzogc3RyaW5nKTogc3RyaW5nIHtcbiAgY29uc3QgaWQgPSB1c2VNZW1vKCgpID0+IHJhbmRvbSgpLnRvU3RyaW5nKDM2KS5zdWJzdHIoMiwgNSksIFtdKTtcblxuICBwcmVmaXggPSBwcmVmaXggPyBgJHtwcmVmaXh9LS1gIDogJyc7XG5cbiAgcmV0dXJuIGAke3ByZWZpeH0ke2lkfWA7XG59XG4iXX0=